import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketSchedulesEventSubscription = () => {
  const { invalidateListSchedules } = SchedulerV3.Helpers.useSchedulerV3InvalidateQueries();

  // Invalidate schedules for the entity when a schedule is created, updated or deleted
  return useWebsocketEventSubscription(NotificationType.SCHEDULE_CHANGED, (payload) => {
    const entityId = payload.params.changeType === 'PROVIDER' ? payload.params.providerId : payload.params.locationId;
    invalidateListSchedules([entityId || '']);
  });
};
